"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolvedInputsToInputCells = exports.inputCellsToResolvedInputs = void 0;
function inputCellsToResolvedInputs(inputs, filter) {
    if (filter instanceof Function) {
        inputs = inputs.filter(filter);
    }
    return inputs.reduce((sum, input) => {
        sum.outputs.push(input.cellOutput);
        sum.outputsData.push(input.data);
        return sum;
    }, {
        outputs: [],
        outputsData: [],
    });
}
exports.inputCellsToResolvedInputs = inputCellsToResolvedInputs;
function resolvedInputsToInputCells(inputs, resolvedInputs) {
    return inputs.map((input, index) => {
        return {
            cellOutput: resolvedInputs.outputs[index],
            data: resolvedInputs.outputsData[index],
            outPoint: input.previousOutput,
        };
    });
}
exports.resolvedInputsToInputCells = resolvedInputsToInputCells;
//# sourceMappingURL=resolvedInputs.js.map